import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import { Group } from '../../../models/group.model';
import { GroupContext } from '../../../models/group-context.model';
import { User } from '../../../models/user.model';
import { AdminService } from '../../../services/admin.service';
import { UserService } from '../../../services/user.service';
import { VacationGroupPresenceResponse } from '../../common/vacation/vacation.models';
import { VIEW_GROUP_ROUTE_PARAMETERS } from './view-group.constants';
import { SortCriterion, VectorUserListResponse } from './view-group.types';
import { EmployeeProbationResponse } from '../../common/employee-probation/employee-probation.models';

@Injectable()
export class ViewGroupDataPort {
	constructor(
		private adminService: AdminService,
		private userService: UserService,
		private route: ActivatedRoute
	) {}

	currentUser(): User {
		return this.userService.getLocal();
	}

	routeGroupId(): string | number {
		return this.route.snapshot.params[VIEW_GROUP_ROUTE_PARAMETERS.GROUP_ID];
	}

	routeGroupIds(): Observable<string | number> {
		return this.route.params.map(params => params[VIEW_GROUP_ROUTE_PARAMETERS.GROUP_ID]).distinctUntilChanged();
	}

	isReportMode(): boolean {
		return !!this.route.snapshot.params[VIEW_GROUP_ROUTE_PARAMETERS.REPORT_MODE];
	}

	loadGroup(groupId: string | number): Observable<HttpResponse<Group>> {
		return this.adminService.getGroupByID(groupId);
	}

	loadGroupContext(groupId: string | number): Observable<HttpResponse<GroupContext>> {
		return this.adminService.getGroupContext(groupId);
	}

	loadHeadGroups(): Observable<HttpResponse<Group[]>> {
		return this.adminService.getGroupsAndPositionsHead();
	}

	loadAllGroups(): Observable<HttpResponse<Group[]>> {
		return this.adminService.getAllGroups();
	}

	loadVectors(
		groupId: string,
		_isAdmin: boolean,
		criteria: SortCriterion[]
	): Observable<VectorUserListResponse> {
		return this.adminService.getListVectorsNoSalary(groupId, criteria);
	}

	loadCombinedVectors(groupId: string, criteria: SortCriterion[]): Observable<VectorUserListResponse> {
		return this.adminService.getListVectorsNoSalary(groupId, criteria, true);
	}

	loadVacationPresence(groupId: string, includeSubdepartments = false): Observable<VacationGroupPresenceResponse> {
		return this.adminService.getVacationGroupPresence(groupId, includeSubdepartments);
	}

	deleteMember(userId: string | number, groupId: string): Observable<HttpResponse<Object>> {
		return this.userService.deleteUserFromGroup(userId, groupId);
	}

	approveProbationDuringDeployment(userId: string): Observable<HttpResponse<EmployeeProbationResponse>> {
		return this.userService.approveProbationDuringDeployment(userId);
	}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/view-group-data.port.ts